import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { NormalModeIOHFilterComponent } from './components/normal-mode-ioh-filter/normal-mode-ioh-filter.component';

@Component({
  selector: 'ioh-csx-filter',
  templateUrl: './ioh-filter.component.html',
  styleUrls: ['./ioh-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NormalModeIOHFilterComponent]
})
export class IOHFilterComponent {
  @Input() level = 0;
  @Output() showFilterChange: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  //method for show filter flag change
  onShowFilterChanges(iohShowFilter: boolean) {
    this.showFilterChange.emit(iohShowFilter);
  }
}
